import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { FBXLoader } from "three/addons/loaders/FBXLoader.js";
import { FontLoader } from "three/addons/loaders/FontLoader.js";
import EventEmitter from "./EventEmitter.js";

export default class Resources extends EventEmitter {
  constructor(sources) {
    super();
    this.sources = sources;
    // Setup
    this.items = {};
    this.toLoad = this.sources.length;
    this.loaded = 0;
    this.setLoaders();
    this.startLoading();
  }

  setLoaders() {
    this.loaders = {};
    this.loaders.glbLoader = new GLTFLoader();
    this.loaders.gltfLoader = new GLTFLoader();
    this.loaders.fbxLoader = new FBXLoader();
    this.loaders.textureLoader = new THREE.TextureLoader();
    this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader();
    this.loaders.fontLoader = new FontLoader();
  }
  startLoading() {
    // Load each source
    for (const source of this.sources) {
      if (source.type === "gltfModel") {
        this.loaders.gltfLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file);
        });
      } else if (source.type === "glbModel") {
        this.loaders.glbLoader.load(source.path, (glb) => {
          this.sourceLoaded(source, glb);
        });
      } else if (source.type === "fbxModel") {
        this.loaders.fbxLoader.load(source.path, (fbx) => {
          this.sourceLoaded(source, fbx);
        });
      } else if (source.type === "texture") {
        this.loaders.textureLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file);
        });
      } else if (source.type === "cubeTexture") {
        this.loaders.cubeTextureLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file);
        });
      } else if (source.type === "font") {
        this.loaders.fontLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file);
        });
      } else if (source.type === "simulationData") {
        fetch(source.path, {
          headers: {
            Accept: "application/json",
          },
        })
          .then((response) => {
            console.log(response);
            return response.json();
          })
          .then((data) => {
            this.sourceLoaded(source, data);
            // log, loaded the simulation data source.
          });
      }
    }
  }

  sourceLoaded(source, file) {
    this.items[source.name] = file;

    this.loaded++;

    if (this.loaded === this.toLoad) {
      let loading = document.getElementById("loading");
      loading.style.display = "none";
      this.trigger("ready");
    }
  }
}
